import script from "./TextBlockHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextBlockHandler.vue?vue&type=script&lang=ts&setup=true"

import "./TextBlockHandler.vue?vue&type=style&index=0&id=c8ac793c&lang=less"

const __exports__ = script;

export default __exports__